import Carousel from 'react-slick';
import slickCarouselCSS from 'components/styles/SlickCarousel';
import { DealerListing } from 'lib/models/DealerListing';
import CarouselVehicleCard from 'components/DealerListingsCarousel/CarouselVehicleCard';

interface Props {
  vehicles: DealerListing[];
}

function DesktopSearchResultsCarousel({ vehicles }: Props): JSX.Element {
  const settings = {
    infinite: false,
    variableWidth: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  return (
    <div className="vehicles" data-testid="desktop-carousel">
      <Carousel className={slickCarouselCSS.className} {...settings}>
        {vehicles.map((vehicle, index) => (
          <CarouselVehicleCard {...vehicle} key={vehicle.vin} position={index + 1} />
        ))}
        <div className="blank-slide-hack" />
      </Carousel>

      {slickCarouselCSS.styles}

      <style jsx>{`
        .vehicles {
          position: relative;
          margin-top: 10px;
          width: 100%;
        }

        /* HACK:
          slick with the variableWidth=true setting will stop scrolling when
          the last slide is partially cut off, so insert a blank slide to ensure
          the carousel will scroll enough to see all the listings.
          */
        .blank-slide-hack {
          width: 300px;
        }
      `}</style>
    </div>
  );
}

export default DesktopSearchResultsCarousel;
